export default __webpack_public_path__ + "static/media/blog-post-layout-03-img-04.0da89251.jpg";